import React from 'react';
// import { Box } from '@chakra-ui/react';
import Plugin, { PluginProps } from '../Plugin';

const PresentationBlock = (props: PluginProps) => {
  const { content } = props;
  return (
    <>
      {content.children.map((child, index) => {
        return <Plugin key={index} {...props} content={child} />;
      })}
    </>
  );
};

export default PresentationBlock;
